import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NumberInput } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/Number';
/**
 * @class NCNumber
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCNumber
 * @label 数字
 *
 */
class NCNumber extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title 精度
         * @description 精度
         */
        scale: PropTypes.number,
        /**
         * @title 非格式化数据
         * @description 非格式化数据
         */
        noDataFormat: PropTypes.bool,
        /**
         * @title 自动化Id
         * @description 自动化Id
         */
        fieldid: PropTypes.string,
        /**
         * @title 校验
         * @description 校验
         */
        verify: PropTypes.bool,
        /**
         * @title 值
         * @description 值
         */
        value: PropTypes.string,
        /**
         * @title 禁用
         * @description 禁用
         */
        disabled: PropTypes.bool,
        /**
        * @title 最大长度
        * @description 最大长度
        */
        maxlength: PropTypes.number,


    }

    static defaultProps = {
        verify: true,
        scale: 0,
        value: '',
        disabled: false,

    }
    static getCompMeta = () => {
        return CompMeta;
    }
    render() {
        return (
            <NumberInput {...this.props} />
        )
    }
}

export default NCNumber;
